// noinspection DuplicatedCode
// Perjalanan Dinas Fase 2: form Perubahan Agenda & Laporan (LPD) + tampilan read-only
// (dipakai juga oleh modal Daftar Approval).
import React, { useEffect, useState } from "react";

import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";

import {
  JENIS_BIAYA,
  insertLaporan,
  insertUbah,
  rupiah,
  tglIndo,
  unduhBukti,
  updateLaporan,
  updateUbah,
  uploadBukti,
} from "./perjalananDinasApi";

const INPUT =
  "appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500";
const LABEL = "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2";
const ymd = (d) =>
  d instanceof Date && !isNaN(d.getTime())
    ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`
    : "";
const dariYmd = (s) => (s ? new Date(`${s}T00:00:00`) : "");

// ═══════ Form Perubahan Agenda ═══════
// pd = pengajuan induk (baris daftar); ubah = dokumen perubahan yang diedit (atau null = baru).
export const UbahModal = ({ show, pd, ubah, onClose, onSaved }) => {
  const [mulai, setMulai] = useState("");
  const [selesai, setSelesai] = useState("");
  const [tujuan, setTujuan] = useState("");
  const [tambahan, setTambahan] = useState("0");
  const [alasan, setAlasan] = useState("");
  const [coba, setCoba] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!show || !pd) return;
    setCoba(false);
    setMulai(dariYmd(ubah ? ubah.TanggalMulaiBaru : pd.TanggalMulai));
    setSelesai(dariYmd(ubah ? ubah.TanggalSelesaiBaru : pd.TanggalSelesai));
    setTujuan(ubah ? ubah.TujuanBaru : pd.Tujuan);
    setTambahan(ubah ? String(ubah.TambahanBiaya) : "0");
    setAlasan(ubah ? ubah.Alasan : "");
  }, [show, pd, ubah]);

  if (!pd) return null;
  const hariBaru =
    mulai instanceof Date && selesai instanceof Date && selesai >= mulai ? Math.round((selesai - mulai) / 86400000) + 1 : 0;

  const simpan = async () => {
    setCoba(true);
    if (!(mulai instanceof Date) || !(selesai instanceof Date) || selesai < mulai || !tujuan.trim() || !alasan.trim()) return;
    const body = {
      UbahID: ubah?.UbahID || "",
      PerjalananDinasID: pd.PerjalananDinasID,
      TanggalMulaiBaru: ymd(mulai),
      TanggalSelesaiBaru: ymd(selesai),
      TujuanBaru: tujuan,
      TambahanBiaya: Number(tambahan) || 0,
      Alasan: alasan,
    };
    setSaving(true);
    try {
      if (ubah) await updateUbah(body);
      else await insertUbah(body);
      toast.success("Perubahan agenda disimpan (kirim dari halaman Detail)", { position: "bottom-right", autoClose: 3000 });
      onSaved();
    } catch (e) {
      toast.error(e.message, { position: "bottom-right" });
    }
    setSaving(false);
  };

  return (
    <Modal size="lg" active={show} toggler={() => {}}>
      <ModalHeader className="mt-20" toggler={onClose}>
        {ubah ? `Edit Perubahan ${ubah.UbahID}` : "Ajukan Perubahan Agenda"} — {pd.PerjalananDinasID}
      </ModalHeader>
      <ModalBody>
        <div className="text-sm text-gray-600 mb-4">
          Saat ini: <b>{pd.Tujuan}</b>, {tglIndo(pd.TanggalMulai)} s/d {tglIndo(pd.TanggalSelesai)} ({pd.JumlahHari} hari). Setelah
          disetujui, durasi, uang saku dan estimasi biaya pengajuan ikut berubah.
        </div>
        <div className="flex flex-wrap -mx-3 mb-6">
          <div className="w-full px-3">
            <label className={LABEL}>Tujuan *</label>
            <input value={tujuan} onChange={(e) => setTujuan(e.target.value)} maxLength={255} className={INPUT} />
            {coba && !tujuan.trim() && <p className="text-red-500 text-xs italic">Tujuan wajib diisi</p>}
          </div>
        </div>
        <div className="flex flex-wrap -mx-3 mb-2">
          <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <label className={LABEL}>Tanggal Berangkat Baru *</label>
            <DatePicker
              dateFormat="dd/MM/yyyy"
              selected={mulai || null}
              onChange={(d) => {
                setMulai(d);
                if (d && selesai && selesai < d) setSelesai(d);
              }}
              className={INPUT}
            />
          </div>
          <div className="w-full md:w-1/2 px-3">
            <label className={LABEL}>Tanggal Selesai Baru *</label>
            <DatePicker dateFormat="dd/MM/yyyy" selected={selesai || null} minDate={mulai || null} onChange={setSelesai} className={INPUT} />
          </div>
        </div>
        <div className="mb-6 text-sm text-gray-600">
          {hariBaru > 0 && (
            <>
              Durasi baru: <b>{hariBaru} hari</b>
              {pd.Kategori === "Penugasan" && Number(pd.TarifUangSaku) > 0 && (
                <> — uang saku menjadi {rupiah(Number(pd.TarifUangSaku) * hariBaru)}</>
              )}
            </>
          )}
        </div>
        <div className="flex flex-wrap -mx-3 mb-6">
          <div className="w-full md:w-1/2 px-3">
            <label className={LABEL}>Tambahan / Pengurangan Estimasi Biaya (Rp)</label>
            <input
              value={tambahan}
              inputMode="decimal"
              onChange={(e) => setTambahan(e.target.value.replace(/[^0-9.-]/g, ""))}
              className={INPUT + " text-right"}
            />
            <p className="text-xs text-gray-500 mt-1">Isi negatif bila biaya berkurang. Saat ini: {rupiah(pd.EstimasiBiaya)}</p>
          </div>
        </div>
        <div className="flex flex-wrap -mx-3 mb-2">
          <div className="w-full px-3">
            <label className={LABEL}>Alasan Perubahan *</label>
            <textarea value={alasan} onChange={(e) => setAlasan(e.target.value)} rows={3} className={INPUT} />
            {coba && !alasan.trim() && <p className="text-red-500 text-xs italic">Alasan wajib diisi</p>}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="red" buttonType="link" onClick={onClose} ripple="dark">
          Batal
        </Button>
        <Button color="green" onClick={simpan} ripple="light" disabled={saving}>
          {saving ? "MENYIMPAN…" : "SIMPAN"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

// ═══════ Form Laporan (LPD) ═══════
const BARIS_LPD = { Jenis: "Tiket Perjalanan", Keterangan: "", Nominal: "", FileBukti: "", NoBukti: "" };
const BARIS_KEGIATAN = { Tanggal: "", Lokasi: "", Kegiatan: "", Hasil: "" };

export const LaporanModal = ({ show, pd, laporan, onClose, onSaved }) => {
  const [hasil, setHasil] = useState("");
  const [uangMuka, setUangMuka] = useState("0");
  const [biaya, setBiaya] = useState([{ ...BARIS_LPD }]);
  const [kegiatan, setKegiatan] = useState([{ ...BARIS_KEGIATAN }]);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(-1);
  const [coba, setCoba] = useState(false);

  useEffect(() => {
    if (!show || !pd) return;
    setCoba(false);
    setHasil(laporan?.HasilPerjalanan || "");
    setUangMuka(String(laporan ? laporan.UangMukaDiterima : pd.JenisDana === "UangMuka" ? pd.EstimasiBiaya : 0));
    setBiaya(
      laporan?.Biaya?.length ? laporan.Biaya.map((b) => ({ ...b, NoBukti: b.NoBukti || "", Nominal: String(b.Nominal) })) : [{ ...BARIS_LPD }]
    );
    // Laporan Pelaksanaan: laporan tersimpan, atau salinan Rincian Tugas pengajuan (tanggal/lokasi/kegiatan) sebagai awal.
    setKegiatan(
      laporan?.Kegiatan?.length
        ? laporan.Kegiatan.map((k) => ({ ...k }))
        : pd.Rincian?.length
        ? pd.Rincian.map((r) => ({ Tanggal: r.Tanggal, Lokasi: r.Lokasi || "", Kegiatan: r.Kegiatan, Hasil: "" }))
        : [{ ...BARIS_KEGIATAN }]
    );
  }, [show, pd, laporan]);

  if (!pd) return null;
  const uangMukaPD = pd.JenisDana === "UangMuka";
  // Fase 3: bila uang muka sudah jadi dokumen Finance, nominal dokumen yang berlaku (server).
  const uangMukaDokumen = uangMukaPD && !!pd.UangMukaCashJournalID && pd.UangMukaCashJournalID !== "(proses)";
  const total = biaya.reduce((s, b) => s + (Number(b.Nominal) || 0), 0);
  const uangSaku = pd.Kategori === "Penugasan" ? Number(pd.EstimasiUangSaku) || 0 : 0;
  const uangMukaPakai = uangMukaDokumen
    ? laporan
      ? Number(laporan.UangMukaDiterima) || 0
      : (Number(pd.EstimasiBiaya) || 0) + uangSaku
    : Number(uangMuka) || 0;
  const selisih = total + uangSaku - (uangMukaPD ? uangMukaPakai : 0);

  const setKeg = (i, k, v) => setKegiatan((l) => l.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  const kegiatanIsi = kegiatan.filter((k) => k.Tanggal || k.Lokasi || k.Kegiatan.trim() || k.Hasil.trim());
  const adaHasil = hasil.trim() || kegiatanIsi.some((k) => k.Hasil.trim());
  const anggaranDari = (jenis) =>
    (laporan?.AnggaranBiaya || pd.Biaya || []).filter((x) => x.Jenis === jenis).reduce((a, x) => a + (Number(x.Nominal) || 0), 0);
  const setBaris = (i, patch) => setBiaya((l) => l.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  const pilihFile = async (i, file) => {
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) {
      toast.error("Ukuran file maksimal 10 MB", { position: "bottom-right" });
      return;
    }
    setUploading(i);
    try {
      setBaris(i, { FileBukti: await uploadBukti(file) });
    } catch (e) {
      toast.error(e.message, { position: "bottom-right" });
    }
    setUploading(-1);
  };

  const simpan = async () => {
    setCoba(true);
    if (pd.Kategori === "Penugasan" && !adaHasil) return;
    if (kegiatanIsi.some((k) => !k.Tanggal || !k.Kegiatan.trim())) {
      toast.error("Setiap baris Laporan Pelaksanaan wajib punya tanggal dan kegiatan.", { position: "bottom-right" });
      return;
    }
    const body = {
      LaporanID: laporan?.LaporanID || "",
      PerjalananDinasID: pd.PerjalananDinasID,
      HasilPerjalanan: hasil,
      UangMukaDiterima: uangMukaPD ? Number(uangMuka) || 0 : 0,
      Kegiatan: kegiatanIsi,
      Biaya: biaya
        .filter((b) => Number(b.Nominal) || b.Keterangan.trim() || b.FileBukti || (b.NoBukti || "").trim())
        .map((b) => ({
          Jenis: b.Jenis,
          Keterangan: b.Keterangan,
          Nominal: Number(b.Nominal) || 0,
          FileBukti: b.FileBukti,
          NoBukti: (b.NoBukti || "").trim(),
        })),
    };
    setSaving(true);
    try {
      if (laporan) await updateLaporan(body);
      else await insertLaporan(body);
      toast.success("Laporan disimpan (kirim dari halaman Detail)", { position: "bottom-right", autoClose: 3000 });
      onSaved();
    } catch (e) {
      toast.error(e.message, { position: "bottom-right" });
    }
    setSaving(false);
  };

  return (
    <Modal size="lg" active={show} toggler={() => {}}>
      <ModalHeader className="mt-20" toggler={onClose}>
        {laporan ? `Edit Laporan ${laporan.LaporanID}` : "Laporan Perjalanan Dinas"} — {pd.PerjalananDinasID}
      </ModalHeader>
      <ModalBody>
        <div className="text-sm text-gray-600 mb-4">
          {pd.NamaKaryawan} — {pd.Tujuan}, {tglIndo(pd.TanggalMulai)} s/d {tglIndo(pd.TanggalSelesai)}. Batas laporan:{" "}
          <b>{tglIndo(pd.BatasLPD)}</b> (7 hari kerja setelah selesai).
        </div>
        <div className="mb-2 font-semibold text-gray-700 text-sm">
          Laporan Pelaksanaan Perjalanan Dinas {pd.Kategori === "Penugasan" ? "* (Hasil/Output wajib untuk Dinas Penugasan)" : ""}
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm mb-2" style={{ minWidth: 640 }}>
            <thead className="text-xs uppercase text-gray-500">
              <tr>
                <th className="text-left px-1 pb-1" style={{ width: 140 }}>Tanggal</th>
                <th className="text-left px-1 pb-1">Lokasi</th>
                <th className="text-left px-1 pb-1">Kegiatan / Tugas yang dilaksanakan</th>
                <th className="text-left px-1 pb-1">Hasil / Output</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {kegiatan.map((k, i) => (
                <tr key={i}>
                  <td className="px-1 py-1"><input type="date" value={k.Tanggal} onChange={(e) => setKeg(i, "Tanggal", e.target.value)} className={INPUT + " py-2 px-2"} /></td>
                  <td className="px-1 py-1"><input value={k.Lokasi} maxLength={255} onChange={(e) => setKeg(i, "Lokasi", e.target.value)} className={INPUT + " py-2 px-2"} /></td>
                  <td className="px-1 py-1"><input value={k.Kegiatan} onChange={(e) => setKeg(i, "Kegiatan", e.target.value)} className={INPUT + " py-2 px-2"} /></td>
                  <td className="px-1 py-1"><input value={k.Hasil} onChange={(e) => setKeg(i, "Hasil", e.target.value)} className={INPUT + " py-2 px-2"} /></td>
                  <td className="px-1 py-1">
                    <button type="button" className="text-red-600 px-2 py-1 hover:bg-red-50 rounded" onClick={() => setKegiatan((l) => (l.length > 1 ? l.filter((_, j) => j !== i) : [{ ...BARIS_KEGIATAN }]))}>✕</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <button type="button" onClick={() => setKegiatan((l) => [...l, { ...BARIS_KEGIATAN }])} className="text-blue-600 text-sm font-semibold hover:underline mb-4">
          + Tambah baris
        </button>
        <div className="mb-6">
          <label className={LABEL}>Ringkasan Hasil Perjalanan Dinas (opsional)</label>
          <textarea value={hasil} onChange={(e) => setHasil(e.target.value)} rows={3} className={INPUT} />
          {coba && pd.Kategori === "Penugasan" && !adaHasil && (
            <p className="text-red-500 text-xs italic">Isi Hasil/Output pada salah satu kegiatan atau ringkasan hasil (laporan ke HOD & HR)</p>
          )}
        </div>

        <div className="mb-2 font-semibold text-gray-700 text-sm">Realisasi Biaya (Actual Cost) — lampirkan kuitansi/bukti sah</div>
        {biaya.map((b, i) => (
          <div key={i} className="border rounded p-2 mb-2">
            <div className="flex flex-wrap -mx-1 items-center">
              <div className="w-full sm:w-1/4 px-1 mb-1 sm:mb-0">
                <select value={b.Jenis} onChange={(e) => setBaris(i, { Jenis: e.target.value })} className={INPUT + " py-2"}>
                  {JENIS_BIAYA.map((j) => (
                    <option key={j}>{j}</option>
                  ))}
                </select>
              </div>
              <div className="w-full sm:w-2/5 px-1 mb-1 sm:mb-0">
                <input value={b.Keterangan} placeholder="Keterangan" onChange={(e) => setBaris(i, { Keterangan: e.target.value })} className={INPUT + " py-2"} />
              </div>
              <div className="w-3/4 sm:w-1/5 px-1">
                <input
                  value={b.Nominal}
                  placeholder="Nominal"
                  inputMode="decimal"
                  onChange={(e) => setBaris(i, { Nominal: e.target.value.replace(/[^0-9.]/g, "") })}
                  className={INPUT + " py-2 text-right"}
                />
              </div>
              <div className="w-1/4 sm:w-auto px-1">
                <button
                  type="button"
                  onClick={() => setBiaya((l) => (l.length > 1 ? l.filter((_, j) => j !== i) : [{ ...BARIS_LPD }]))}
                  className="text-red-600 px-2 py-1 hover:bg-red-50 rounded"
                >
                  ✕
                </button>
              </div>
            </div>
            <div className="mt-2 flex items-center gap-2 flex-wrap text-xs text-gray-500">
              <input
                value={b.NoBukti || ""}
                maxLength={100}
                placeholder="No. Bukti/Kwitansi"
                onChange={(e) => setBaris(i, { NoBukti: e.target.value })}
                className={INPUT + " py-1 px-2 text-sm"}
                style={{ maxWidth: 220 }}
              />
              {anggaranDari(b.Jenis) > 0 && <span>Anggaran {b.Jenis}: {rupiah(anggaranDari(b.Jenis))}</span>}
            </div>
            <div className="mt-2 text-sm flex items-center gap-3 flex-wrap">
              {b.FileBukti ? (
                <>
                  <button type="button" className="text-blue-600 hover:underline" onClick={() => unduhBukti(b.FileBukti)}>
                    📎 {b.FileBukti.replace(/^[0-9a-fA-F-]{36}-/, "")}
                  </button>
                  <button type="button" className="text-red-500 text-xs" onClick={() => setBaris(i, { FileBukti: "" })}>
                    ganti
                  </button>
                </>
              ) : (
                <label className={"cursor-pointer " + (Number(b.Nominal) > 0 ? "text-amber-600" : "text-gray-500")}>
                  {uploading === i ? "Mengunggah…" : Number(b.Nominal) > 0 ? "⚠ Lampirkan bukti (wajib)" : "Lampirkan bukti"}
                  <input type="file" className="hidden" accept="image/*,application/pdf" onChange={(e) => pilihFile(i, e.target.files[0])} />
                </label>
              )}
            </div>
          </div>
        ))}
        <button type="button" onClick={() => setBiaya((l) => [...l, { ...BARIS_LPD }])} className="text-blue-600 text-sm font-semibold hover:underline mb-4">
          + Tambah baris
        </button>

        {uangMukaDokumen && (
          <div className="mb-4 text-sm border rounded bg-blue-50 px-3 py-2 text-blue-900">
            Uang muka mengikuti dokumen Finance <b>{pd.UangMukaCashJournalID}</b>
            {pd.UangMukaStatusKet ? ` (${pd.UangMukaStatusKet})` : ""}: <b>{rupiah(uangMukaPakai)}</b>. Laporan baru dapat dikirim
            setelah uang muka dibayar.
          </div>
        )}
        {uangMukaPD && !uangMukaDokumen && (
          <div className="flex flex-wrap -mx-3 mb-4">
            <div className="w-full md:w-1/2 px-3">
              <label className={LABEL}>Uang Muka yang Diterima (Rp)</label>
              <input
                value={uangMuka}
                inputMode="decimal"
                onChange={(e) => setUangMuka(e.target.value.replace(/[^0-9.]/g, ""))}
                className={INPUT + " text-right"}
              />
              <p className="text-xs text-gray-500 mt-1">Default = estimasi biaya pengajuan. Sesuaikan bila yang diterima berbeda.</p>
            </div>
          </div>
        )}

        <RingkasanSettlement total={total} uangSaku={uangSaku} uangMuka={uangMukaPD ? uangMukaPakai : 0} selisih={selisih} />
      </ModalBody>
      <ModalFooter>
        <Button color="red" buttonType="link" onClick={onClose} ripple="dark">
          Batal
        </Button>
        <Button color="green" onClick={simpan} ripple="light" disabled={saving || uploading >= 0}>
          {saving ? "MENYIMPAN…" : "SIMPAN"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const arahTeks = (selisih) =>
  selisih > 0
    ? "Kurang bayar — perusahaan membayar kekurangan ke karyawan (klaim reimbursement)"
    : selisih < 0
    ? "Lebih bayar — karyawan mengembalikan kelebihan uang muka"
    : "Pas — tidak ada selisih";

export const RingkasanSettlement = ({ total, uangSaku, uangMuka, selisih }) => (
  <div className="border rounded bg-gray-50 p-3 text-sm">
    <div className="flex justify-between"><span>Total realisasi biaya</span><span>{rupiah(total)}</span></div>
    <div className="flex justify-between"><span>Uang saku (hari disetujui)</span><span>{rupiah(uangSaku)}</span></div>
    <div className="flex justify-between"><span>Uang muka diterima</span><span>− {rupiah(uangMuka)}</span></div>
    <div className="flex justify-between font-bold border-t mt-1 pt-1">
      <span>Selisih</span>
      <span className={selisih > 0 ? "text-green-700" : selisih < 0 ? "text-red-600" : ""}>{rupiah(selisih)}</span>
    </div>
    <div className="text-xs text-gray-600 mt-1">{arahTeks(selisih)}</div>
  </div>
);

// ═══════ Tampilan read-only (modal Detail & Daftar Approval) ═══════
const Aktor = ({ list }) =>
  Array.isArray(list) && list.length > 0 ? (
    <div className="space-y-2">
      {list.map((a, i) => (
        <div key={i} className="border rounded px-4 py-2 flex items-center justify-between gap-2 text-sm">
          <span className="font-medium text-gray-800">
            {a.Urutan ? `${a.Urutan}. ` : ""}
            {a.Nama}
          </span>
          <span className="text-gray-500 text-xs text-right">
            {a.Keterangan} {a.Status}
          </span>
        </div>
      ))}
    </div>
  ) : (
    <div className="text-gray-400 text-sm">-</div>
  );

export const DetailUbah = ({ u }) => (
  <div className="w-full">
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4 text-sm">
      <div><div className="text-xs font-bold uppercase text-gray-500">Pengajuan</div>{u.PerjalananDinasID} — {u.NamaKaryawan}</div>
      <div><div className="text-xs font-bold uppercase text-gray-500">Status</div>{u.StatusKet}</div>
      <div>
        <div className="text-xs font-bold uppercase text-gray-500">Semula</div>
        {u.TujuanLama}, {tglIndo(u.TanggalMulaiLama)} s/d {tglIndo(u.TanggalSelesaiLama)} ({u.JumlahHariLama} hari)
      </div>
      <div>
        <div className="text-xs font-bold uppercase text-gray-500">Menjadi</div>
        <b>{u.TujuanBaru}, {tglIndo(u.TanggalMulaiBaru)} s/d {tglIndo(u.TanggalSelesaiBaru)} ({u.JumlahHariBaru} hari)</b>
      </div>
      <div><div className="text-xs font-bold uppercase text-gray-500">Tambahan Estimasi Biaya</div>{rupiah(u.TambahanBiaya)}</div>
      <div className="sm:col-span-2"><div className="text-xs font-bold uppercase text-gray-500">Alasan</div><span className="whitespace-pre-line">{u.Alasan}</span></div>
    </div>
    <div className="border-t pt-3 mb-2 font-semibold text-gray-700">Alur Approval Perubahan Agenda</div>
    <Aktor list={u.ApprovalList} />
  </div>
);

const FinanceLaporan = ({ l, onProsesUlang }) => {
  const butuhSelisih = Number(l.Selisih) !== 0;
  const kurangSelisih = String(l.Status) === "99" && butuhSelisih && !l.SelisihCashJournalID;
  const kurangReklas =
    String(l.Status) === "99" && l.JenisDana === "UangMuka" && Number(l.UangMukaDiterima) > 0 && Number(l.TotalRealisasi) + Number(l.UangSaku) > 0 && !l.ReklasAccountingID;
  if (!l.UangMukaCashJournalID && !l.SelisihCashJournalID && !l.ReklasAccountingID && !kurangSelisih && !kurangReklas) return null;
  return (
    <div className="border rounded p-3 text-sm mt-3">
      <div className="font-semibold text-gray-700 mb-1">Dokumen Finance</div>
      {l.UangMukaCashJournalID && (
        <div>Uang muka: <b>{l.UangMukaCashJournalID}</b> — {l.UangMukaStatusKet}</div>
      )}
      {l.ReklasAccountingID && <div>Jurnal pindah uang muka → beban HR: <b>{l.ReklasAccountingID}</b></div>}
      {l.SelisihCashJournalID && (
        <div>
          {Number(l.Selisih) > 0 ? "Pembayaran kekurangan" : "Pengembalian kelebihan"}: <b>{l.SelisihCashJournalID}</b> — {l.SelisihStatusKet}
        </div>
      )}
      {(kurangSelisih || kurangReklas) && (
        <div className="text-amber-700 mt-1">
          Dokumen Finance belum lengkap terbentuk.{" "}
          {onProsesUlang && (
            <button type="button" className="underline font-semibold" onClick={() => onProsesUlang(l)}>
              Proses ulang Finance
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export const DetailLaporan = ({ l, onProsesUlang }) => (
  <div className="w-full">
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4 text-sm">
      <div><div className="text-xs font-bold uppercase text-gray-500">Pengajuan</div>{l.PerjalananDinasID} — {l.NamaKaryawan}</div>
      <div><div className="text-xs font-bold uppercase text-gray-500">Status Laporan</div>{l.StatusKet}</div>
      <div><div className="text-xs font-bold uppercase text-gray-500">Perjalanan</div>{l.Tujuan}, {tglIndo(l.TanggalMulai)} s/d {tglIndo(l.TanggalSelesai)} ({l.JumlahHari} hari)</div>
      <div>
        <div className="text-xs font-bold uppercase text-gray-500">Batas Laporan</div>
        {tglIndo(l.BatasLPD)}
        {l.TerlambatLPD && <span className="ml-2 text-amber-600 font-semibold">⚠ Dikirim terlambat</span>}
      </div>
      <div className="sm:col-span-2"><div className="text-xs font-bold uppercase text-gray-500">Hasil Perjalanan</div><span className="whitespace-pre-line">{l.HasilPerjalanan || "-"}</span></div>
    </div>
    {Array.isArray(l.Kegiatan) && l.Kegiatan.length > 0 && (
      <>
        <div className="font-semibold text-gray-700 text-sm mb-1">Laporan Pelaksanaan</div>
        <table className="w-full text-sm mb-4">
          <thead><tr className="text-xs uppercase text-gray-500 text-left"><th>Tanggal</th><th>Lokasi</th><th>Kegiatan</th><th>Hasil / Output</th></tr></thead>
          <tbody>
            {l.Kegiatan.map((k, i) => (
              <tr key={i} className="border-b">
                <td className="py-1 pr-2 whitespace-nowrap">{tglIndo(k.Tanggal)}</td>
                <td className="py-1 pr-2">{k.Lokasi || "-"}</td>
                <td className="py-1 pr-2">{k.Kegiatan}</td>
                <td className="py-1 text-gray-600">{k.Hasil || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    )}
    {Array.isArray(l.Biaya) && l.Biaya.length > 0 && (
      <table className="w-full text-sm mb-4">
        <thead><tr className="text-xs uppercase text-gray-500 text-left"><th>Komponen</th><th>Keterangan</th><th>No. Bukti</th><th>Bukti</th><th className="text-right">Anggaran</th><th className="text-right">Realisasi</th><th className="text-right">Selisih</th></tr></thead>
        <tbody>
          {l.Biaya.map((b, i) => {
            const ang = (l.AnggaranBiaya || []).filter((x) => x.Jenis === b.Jenis).reduce((a, x) => a + (Number(x.Nominal) || 0), 0);
            return (
            <tr key={i} className="border-b">
              <td className="py-1 pr-2">{b.Jenis}</td>
              <td className="py-1 pr-2 text-gray-500">{b.Keterangan}</td>
              <td className="py-1 pr-2">{b.NoBukti || "-"}</td>
              <td className="py-1 pr-2">
                {b.FileBukti ? (
                  <button type="button" className="text-blue-600 hover:underline" onClick={() => unduhBukti(b.FileBukti)}>📎 unduh</button>
                ) : (
                  <span className="text-gray-400">-</span>
                )}
              </td>
              <td className="py-1 text-right text-gray-500">{ang ? rupiah(ang) : "-"}</td>
              <td className="py-1 text-right">{rupiah(b.Nominal)}</td>
              <td className="py-1 text-right">{ang ? rupiah(Number(b.Nominal) - ang) : "-"}</td>
            </tr>
            );
          })}
        </tbody>
      </table>
    )}
    <RingkasanSettlement total={l.TotalRealisasi} uangSaku={l.UangSaku} uangMuka={l.UangMukaDiterima} selisih={l.Selisih} />
    <FinanceLaporan l={l} onProsesUlang={onProsesUlang} />
    {l.SettlementStatus !== "TidakAda" && (
      <div className="text-sm mt-2">
        Settlement: <b>{l.SettlementStatus === "Selesai" ? "Selesai" : "Menunggu penyelesaian"}</b>
        {l.SettlementStatus === "Selesai" && ` — ${l.SettlementOleh}, ${l.SettlementTanggal}${l.SettlementCatatan ? " — " + l.SettlementCatatan : ""}`}
      </div>
    )}
    <div className="border-t pt-3 my-2 font-semibold text-gray-700">Alur Approval Pertanggungjawaban</div>
    <Aktor list={l.ApprovalList} />
  </div>
);
